import axios from 'axios'
import baseUrl from 'store/slices/api/baseUrl'

const DEFAULT_INVOICE_FILE_NAME = 'invoice.pdf'

const getInvoiceFileName = (contentDisposition, fallbackFileName) => {
    if (!contentDisposition?.length) {
        return fallbackFileName
    }

    const utf8Name = contentDisposition.match(/filename\*=UTF-8''([^;]+)/i)?.[1]
    if (utf8Name) {
        try {
            return decodeURIComponent(utf8Name)
        } catch (_err) {
            return utf8Name
        }
    }

    const plainName = contentDisposition.match(/filename="?([^";]+)"?/i)?.[1]
    return plainName || fallbackFileName
}

const getFallbackFileName = (invoiceNumber) => {
    if (!invoiceNumber && invoiceNumber !== 0) {
        return DEFAULT_INVOICE_FILE_NAME
    }

    return `invoice-${invoiceNumber}.pdf`
}

export const downloadInvoicePdf = async (invoiceId, invoiceNumber) => {
    const response = await axios({
        url: `${baseUrl}/invoices/${invoiceId}/pdf`,
        method: 'GET',
        withCredentials: true,
        responseType: 'blob',
    })

    if (typeof window === 'undefined' || typeof document === 'undefined') {
        throw new Error('File download is only supported in browser mode')
    }

    const fallbackFileName = getFallbackFileName(invoiceNumber)
    const fileName = getInvoiceFileName(response?.headers?.['content-disposition'], fallbackFileName)
    const fileBlob =
        response?.data instanceof Blob
            ? response.data
            : new Blob([response?.data], {type: 'application/pdf'})

    const downloadUrl = window.URL.createObjectURL(fileBlob)
    const link = document.createElement('a')
    link.href = downloadUrl
    link.download = fileName

    document.body.appendChild(link)
    link.click()
    link.remove()

    window.URL.revokeObjectURL(downloadUrl)

    return {fileName}
}
